import React from 'react';
import './sec7.css'
import Cardsec7 from '../components/common/cards-sec7';
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import CTAsec6 from '../components/common/cta-sec6';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';



const Sec7 = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

 const [animate, setAnimate] = useState(false);
    const [wasInView, setWasInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.querySelector('.sec7');

            if (section) {
                const rect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const isInView = rect.top < windowHeight && rect.bottom > 0;

                if (isInView && !wasInView) {
                    setAnimate(false);
                    setTimeout(() => {
                        setAnimate(true);
                    }, 50);
                    setWasInView(true);
                }

                if (!isInView && wasInView) {
                    setAnimate(false);
                    setWasInView(false);
                }
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [wasInView]);





    return ( 
        <section  className={`sec7 ${animate ? 'animate' : ''}`}dir={direction}>
                <article className='container-sec7'>
                    <h1 className='header-sec7'> {t('What Our Users Say')}</h1>
                    <article className='cards-container-sec7'>
                        <Cardsec7 img={pic25} title={t('Ahmad Waild' )}
                        numb={t('5' )}
                        para={t('Amazing platform! Found tickets  to my favorite concert in minutes. The booking process was smooth and easy.' )}/>

                        <Cardsec7 img={pic26} title= {t('Sara Ayman' )}
                        numb={t('5' )}
                        para={t('Love the variety of events! MusicTicket always has the best lineup.Customer service is top-notch too.')}/>

                        <Cardsec7 img={pic27} title= {t('Lara Ahmad')}
                        numb={t('4.5')}
                        para={t('Best ticket platform ever! Great prices and the mobile app makes everything so convenient.')}/>

                    </article>
                    
                    <button className='button-sec7'>
                        <CTAsec6 title={t('View More')} />
                    </button>
                </article>
        </section>
     );
}
 
export default Sec7;